var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyBill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 1.875C4.375 3.28125 3.24219 4.375 1.875 4.375V10.625C3.24219 10.625 4.375 11.7578 4.375 13.125H18.125C18.125 11.7578 19.2188 10.625 20.625 10.625V4.375C19.2188 4.375 18.125 3.28125 18.125 1.875H4.375ZM0 2.5C0 1.13281 1.09375 0 2.5 0H20C21.3672 0 22.5 1.13281 22.5 2.5V12.5C22.5 13.9062 21.3672 15 20 15H2.5C1.09375 15 0 13.9062 0 12.5V2.5ZM11.25 3.75C12.5781 3.75 13.7891 4.49219 14.4922 5.625C15.1562 6.79688 15.1562 8.24219 14.4922 9.375C13.7891 10.5469 12.5781 11.25 11.25 11.25C9.88281 11.25 8.67188 10.5469 7.96875 9.375C7.30469 8.24219 7.30469 6.79688 7.96875 5.625C8.67188 4.49219 9.88281 3.75 11.25 3.75Z",
    fill: "#212543"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBill);
export default __webpack_public_path__ + "static/media/money-bill.b59c708cb83153e18cb2071b1c691841.svg";
export { ForwardRef as ReactComponent };